import { Accordion, AccordionDetails, AccordionSummary, Box, FormControlLabel, Grid, styled, Switch, Typography } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ActionStage, ArchitecturalCode, FundingSource, ItemStatus, PriceType, Responsibility, Scope } from "../../../../common/const";
import { useState } from "react";
import moment from "moment";
import { useSelector } from "react-redux";

const DemoTypography = styled(Typography)(({ theme }) => ({
    fontWeight: 'bold',
    fontSize: 13
}));

const DemoTypo = styled(Typography)(({ theme }) => ({
    color: '#1565c0',
    fontSize: 13
}));

const DefaultTypo = styled(Typography)(({ theme }) => ({
    color: 'gray',
    fontSize: 8
}));

const DefaultTypo1 = styled(Typography)(({ theme }) => ({
    color: 'red',
    fontSize: 8
}));

const ItemInformation = ({
    itemData
}) => {
    const { user, roles } = useSelector((state) => state.users);
    const isUser = roles.find((a) => a.id === user?.role_id);
    const [isCatalog, setIsCatalog] = useState(false);

    return (
        <>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography varaint="body1" style={{ fontWeight: 'bold' }}> Item Information</Typography>
                {isUser?.code !== 'orgGuestUser' &&
                (<FormControlLabel control={<Switch onChange={(e) => setIsCatalog(e.target.checked)} />} label="Show Catalog Values" />)}
            </Box>
            <Accordion defaultExpanded>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                >
                    <Typography style={{ fontWeight: 'bold' }}>Overview</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <Typography variant="body2" style={{ fontWeight: 'bold' }}>Basic Information</Typography>
                            <Box display="flex" alignItems="center" gap={1} mt={1}>
                                <DemoTypo variant="body2">Scope:</DemoTypo>
                                <DemoTypography variant="body2">{Scope?.find((a) => a.value === itemData?.scope)?.name || '--'}</DemoTypography>
                            </Box>
                            <Box display="flex" alignItems="center" gap={1}>
                                <DemoTypo variant="body2">Status:</DemoTypo>
                                <DemoTypography variant="body2">{ItemStatus?.find((a) => a.value === itemData?.status)?.name || '--'}</DemoTypography>
                            </Box>
                            <Box display="flex" alignItems="center" gap={1}>
                                <DemoTypo variant="body2">Stage:</DemoTypo>
                                <DemoTypography variant="body2">{ActionStage?.find((a) => a.value === itemData?.stage)?.name || '--'}</DemoTypography>
                            </Box>
                            <Box display="flex" alignItems="center" gap={1}>
                                <DemoTypo variant="body2">State:</DemoTypo>
                                <DemoTypography variant="body2">{itemData?.is_deleted ? 'InActive' : 'Active'}</DemoTypography>
                            </Box>
                            <Box display="flex" alignItems="center" gap={1}>
                                <DemoTypo variant="body2">Need By:</DemoTypo>
                                <DemoTypography variant="body2">{itemData?.need_by_date ? moment(itemData?.need_by_date).format('YYYY-MM-DD') : '--'}</DemoTypography>
                            </Box>
                            <Box display="flex" alignItems="center" gap={1}>
                                <DemoTypo variant="body2">Created By:</DemoTypo>
                                <DemoTypography variant="body2">{`${itemData?.created_user?.first_name} ${itemData?.created_user?.last_name !== null ? itemData?.created_user?.last_name : ''}`}</DemoTypography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="body2" style={{ fontWeight: 'bold' }}>Responsibility / Significant</Typography>
                            <Box display="flex" alignItems="center" gap={1} mt={1}>
                                <DemoTypo variant="body2">Furnish:</DemoTypo>
                                <DemoTypography variant="body2">{(Responsibility?.find((a) => a.value === itemData?.product_data?.furnish_responsibility)?.name || Responsibility?.find((a) => a.value === itemData?.product?.furnish_responsibility)?.name || '--')}</DemoTypography>
                            </Box>
                            {(isCatalog && (Responsibility?.find((a) => a.value === itemData?.product_data?.furnish_responsibility)?.name !== Responsibility?.find((a) => a.value === itemData?.product?.furnish_responsibility)?.name)) && (
                                <Box display="flex" alignItems="center" gap={1}>
                                    <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                                    <DefaultTypo1 variant="body2">{(Responsibility?.find((a) => a.value === itemData?.product?.furnish_responsibility)?.name || '--')}</DefaultTypo1>
                                </Box>
                            )}
                            <Box display="flex" alignItems="center" gap={1}>
                                <DemoTypo variant="body2">Install:</DemoTypo>
                                <DemoTypography variant="body2">{(Responsibility?.find((a) => a.value === itemData?.product_data?.install_responsibility)?.name || Responsibility?.find((a) => a.value === itemData?.product?.install_responsibility)?.name || '--')}</DemoTypography>
                            </Box>
                            {(isCatalog && (Responsibility?.find((a) => a.value === itemData?.product_data?.install_responsibility)?.name !== Responsibility?.find((a) => a.value === itemData?.product?.install_responsibility)?.name)) && (
                                <Box display="flex" alignItems="center" gap={1}>
                                    <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                                    <DefaultTypo1 variant="body2">{(Responsibility?.find((a) => a.value === itemData?.product?.install_responsibility)?.name || '--')}</DefaultTypo1>
                                </Box>
                            )}
                            <Box display="flex" alignItems="center" gap={1}>
                                <DemoTypo variant="body2">Architectural Code:</DemoTypo>
                                <DemoTypography variant="body2">{(ArchitecturalCode?.find((a) => a.value === itemData?.product_data?.architectural_code)?.name || ArchitecturalCode?.find((a) => a.value === itemData?.product?.architectural_code)?.name || '--')}</DemoTypography>
                            </Box>
                            {(isCatalog && (itemData?.product_data?.architectural_code !== itemData?.product?.architectural_code)) && (
                                <Box display="flex" alignItems="center" gap={1}>
                                    <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                                    <DefaultTypo1 variant="body2">{(ArchitecturalCode?.find((a) => a.value === itemData?.product?.architectural_code)?.name || '--')}</DefaultTypo1>
                                </Box>
                            )}
                            <Box display="flex" alignItems="center" gap={1}>
                                <DemoTypo variant="body2">Architecturally Significant:</DemoTypo>
                                <DemoTypography variant="body2">{itemData?.product_data?.architecturally_significant !== undefined ? (itemData?.product_data?.architecturally_significant ? 'Yes' : 'No') : (itemData?.product?.architecturally_significant ? 'Yes' : 'No')}</DemoTypography>
                            </Box>
                            {(isCatalog && itemData?.product_data?.architecturally_significant !== undefined && itemData?.product_data?.architecturally_significant !== itemData?.product?.architecturally_significant) && (
                                <Box display="flex" alignItems="center" gap={1}>
                                    <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                                    <DefaultTypo1 variant="body2">{(itemData?.product?.architecturally_significant ? 'Yes' : 'No') || '--'}</DefaultTypo1>
                                </Box>
                            )}
                            <Box display="flex" alignItems="center" gap={1}>
                                <DemoTypo variant="body2">Spatially Significant:</DemoTypo>
                                <DemoTypography variant="body2">{itemData?.product_data?.spatially_significant !== undefined ? (itemData?.product_data?.spatially_significant ? 'Yes' : 'No') : (itemData?.product?.spatially_significant ? 'Yes' : 'No')}</DemoTypography>
                            </Box>
                            {(isCatalog && itemData?.product_data?.spatially_significant !== undefined && itemData?.product_data?.spatially_significant !== itemData?.product?.spatially_significant) && (
                                <Box display="flex" alignItems="center" gap={1}>
                                    <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                                    <DefaultTypo1 variant="body2">{(itemData?.product?.spatially_significant ? 'Yes' : 'No') || '--'}</DefaultTypo1>
                                </Box>
                            )}
                            <Box display="flex" alignItems="center" gap={1}>
                                <DemoTypo variant="body2">Emergency Power:</DemoTypo>
                                <DemoTypography variant="body2">{itemData?.product_data?.electrical_data?.emergencyPower !== undefined ? (itemData?.product_data?.electrical_data?.emergencyPower ? 'Yes' : 'No') : (itemData?.product?.electrical_data?.emergencyPower ? 'Yes' : 'No')}</DemoTypography>
                            </Box>
                            {(isCatalog && itemData?.product_data?.emergencyPower !== undefined && itemData?.product_data?.electrical_data?.emergencyPower !== itemData?.product?.electrical_data?.emergencyPower) && (
                                <Box display="flex" alignItems="center" gap={1}>
                                    <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                                    <DefaultTypo1 variant="body2">{(itemData?.product?.electrical_data?.emergencyPower ? 'Yes' : 'No') || '--'}</DefaultTypo1>
                                </Box>
                            )}
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="body2" style={{ fontWeight: 'bold' }}>Finanial Details</Typography>
                            <Box display="flex" alignItems="center" gap={1} mt={1}>
                                <DemoTypo variant="body2">Tax Exempt:</DemoTypo>
                                <DemoTypography variant="body2">{itemData?.product_data?.istax ? 'Yes' : 'No'}</DemoTypography>
                            </Box>
                            <Box display="flex" alignItems="center" gap={1}>
                                <DemoTypo variant="body2">Budget:</DemoTypo>
                                <DemoTypography variant="body2">{itemData?.budget?.budget_name || '--'}</DemoTypography>
                            </Box>
                            <Box display="flex" alignItems="center" gap={1}>
                                <DemoTypo variant="body2">Funding Source:</DemoTypo>
                                <DemoTypography variant="body2">{FundingSource.find((a) => a.value === itemData?.funding_source)?.name || '--'}</DemoTypography>
                            </Box>
                            <Box display="flex" alignItems="center" gap={1}>
                                <DemoTypo variant="body2">Price Type:</DemoTypo>
                                <DemoTypography variant="body2">{PriceType?.find((a) => a.value === itemData?.product_data?.price_type)?.name || itemData?.product?.price_type ? `Product ${PriceType?.find((a) => a.value === itemData?.product?.price_type)?.name}` : '--'}</DemoTypography>
                            </Box>
                            {(isCatalog && itemData?.product_data?.price_type !== undefined && itemData?.product_data?.price_type !== itemData?.product?.price_type) && (
                                <Box display="flex" alignItems="center" gap={1}>
                                    <DefaultTypo variant="body2">Catalog Value:</DefaultTypo>
                                    <DefaultTypo1 variant="body2">{PriceType?.find((a) => a.value === itemData?.product?.price_type)?.name || '--'}</DefaultTypo1>
                                </Box>
                            )}
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="body2" style={{ fontWeight: 'bold' }}>Notes</Typography>
                            <Box style={{ height: 'auto', maxHeight: '20vh', overflow: 'auto' }} mt={1}>
                                <Typography style={{ fontSize: 14, textAlign: 'justify' }}>{itemData?.notes || '--'}</Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </>
    )
};

export default ItemInformation;